export default __webpack_public_path__ + "static/media/chevron_rightFasting.8b2c5c85.svg";